import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Geef een algeheel oordeel over de keuring en/of voeg eventueel foto's toe.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Opmerking", -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Bestand(en)", -1)
const _hoisted_5 = { key: 2 }

import { surveyStore } from '@/stores/survey'
import TextEditor from '@/components/TextEditor.vue'
import Uploader from '@/components/Uploader.vue'
import Filelist from '@/components/Filelist.vue'
import axios from 'axios'
import { notification } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyNotesCard',
  setup(__props) {

function addMedia (file:File) : void {
  const formData = new FormData()
  formData.append('files', file)

  axios.post(process.env.VUE_APP_API_URL + '/surveys/' + surveyStore().survey.id + '/media/add', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => {
    surveyStore().survey.media.items.push(r.data.data)
  })
}

function updateMedia (data:{ file:File, mediaId:number }) : void {
  const formData = new FormData()
  formData.append('files', data.file)
  formData.append('mediaId', data.mediaId.toString())

  axios.post(process.env.VUE_APP_API_URL + '/surveys/' + surveyStore().survey.id + '/media/update', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => {
    surveyStore().survey.media.items.forEach((m:{ id:number }, index:number) => {
      if (m.id === data.mediaId) {
        surveyStore().survey.media.items[index] = r.data.data
        notification.success({
          message: 'Afbeelding bijgewerkt.',
          description: 'De afbeelding is succesvol bijgewerkt.',
          duration: 5
        })
      }
    })
  })
}

function deleteFile (file:{ id:number }) : void {
  axios.post(process.env.VUE_APP_API_URL + '/surveys/' + surveyStore().survey.id + '/media/delete', { mediaId: file.id }).then(() => {
    surveyStore().survey.media.items.forEach((m:{ id:number }, index:number) => {
      if (m.id === file.id) {
        surveyStore().survey.media.items.splice(index, 1)
        notification.success({
          message: 'Bestand verwijderd.',
          description: 'Het bestand is succesvol verwijderd.',
          duration: 5
        })
      }
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Opmerkingen",
    bordered: false
  }, {
    default: _withCtx(() => [
      (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
        ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
                ? (_openBlock(), _createBlock(TextEditor, {
                    key: 0,
                    content: _unref(surveyStore)().survey.note,
                    returnOn: "blur",
                    onContentChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(surveyStore)().updateSurvey('note', $event)))
                  }, null, 8, ["content"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_2,
                    _createElementVNode("div", {
                      innerHTML: _unref(surveyStore)().survey.note || '-'
                    }, null, 8, _hoisted_3)
                  ], 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_4,
              (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
                ? (_openBlock(), _createBlock(Uploader, {
                    key: 0,
                    "current-count": _unref(surveyStore)().survey.media.items.length,
                    "upload-button": "",
                    onNewFileUploaded: addMedia
                  }, null, 8, ["current-count"]))
                : _createCommentVNode("", true),
              (_unref(surveyStore)().survey.media.items.length)
                ? (_openBlock(), _createBlock(Filelist, {
                    key: 1,
                    media: _unref(surveyStore)().survey.media.items,
                    onImageEdited: _cache[1] || (_cache[1] = ($event: any) => (updateMedia($event))),
                    onDeleteFile: deleteFile,
                    "can-edit": !_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner,
                    "can-comment": !_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner,
                    "can-delete": !_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner
                  }, null, 8, ["media", "can-edit", "can-comment", "can-delete"]))
                : (!_unref(surveyStore)().isSurveyOwner)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "-"))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})